<template>
    <Table :disabled="disabled">
        <template #thead>
            <tr class="text-white text-base">
                <td
                    v-for="(title, i) in columns"
                    :key="i"
                >
                    {{ title }}
                </td>
                <td v-if="route.name !== routeName.POLICY_BASIC">
                    投資屬性類型
                </td>
                <td v-if="disabled" />
            </tr>
        </template>
        <template #tbody>
            <tr
                v-for="item in investmentList"
                :key="item.id"
                @click="toServicePage(item)"
            >
                <td class="pad:w-40 lg:w-44">
                    {{ item.fullPolicyNo }}
                </td>
                <td class="max-w-[18rem]">
                    {{ item.itemName }}
                </td>
                <td class="min-w-[6.5rem]">
                    {{ item.name }}
                </td>
                <td class="min-w-[6.5rem]">
                    {{ item.cnctStatText }}
                </td>
                <td class="min-w-[6.5rem]">
                    {{ item.effectDateTW }}
                </td>
                <td
                    v-if="route.name !== routeName.POLICY_BASIC"
                    class="min-w-[8.125rem]"
                >
                    {{ item.investTypeText }}
                </td>
                <td
                    v-if="disabled"
                    class="p-0 w-[5.125rem]"
                >
                    <div class="bg-gray-400 text-sm text-white p-1.5">
                        {{ item.memo }}
                    </div>
                </td>
            </tr>
        </template>
    </Table>
</template>

<script>
import routeName from '@/router/constant.js';
import { useRoute } from 'vue-router';
import Table from '@/components/table/Table.vue';

export default {
    name: 'TablePolicy',
    components: {
        Table
    },
    props: {
        investmentList: {
            type: Object,
            required: true
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['toServicePage'],
    setup(props, { emit }) {
        const route = useRoute();
        const columns = ['保單號碼', '主約險種', '被保險人', '契約狀況', '契約始期'];
        const toServicePage = (item) => {
            if (props.disabled) return;
            emit('toServicePage', item);
        };
        return {
            route,
            routeName,
            columns,
            toServicePage
        };
    },
};
</script>
